//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from "vuedraggable";
import dimensions from "./components/Dimensions";
import barcodes from "./components/Barcodes";
import storage from "./components/Storage";
import bought from "./components/Bought";
import sold from "./components/Sold";
import accountingSettings from "./components/AccountingSettings";
import price from "./components/Price";

import numericsimple from "@/components/numericSimple";
import productdetails from "./components/Details";
import structure from "./components/Component";
import { mapActions, mapState } from "vuex";
import router from "../../router";

export default {
  data() {
    return {
      showPriceCalculationDialog: false,
      SupplierStatus: {
        Inactive: 50001
      },
      isSupplierFieldNotSet: false,
      Suppliers: [],
      FilterSuppliers: [],
      selectedProductSupplier: {},
      showSupplierProduct: false,
      internalID: 0,
      productNumber: "",
      article: {
        supplierProduct: [],
        fromDate: null,
        toDate: null,
        country: {
          id: 0
        }
      },
      supplierProduct: [],
      isDeleted: false,
      deleted: "check_circle",
      textClass: "text-green",
      productInfoIcon: "",
      tab: "price",
      detailsTab: "details",
      storageTab: "storage",
      supplierTab: "supplier",
      savedisabled: false
    };
  },
  components: {
    productdetails,
    dimensions,
    accountingSettings,
    price,
    storage,
    bought,
    sold,
    draggable,
    barcodes,
    structure,
    
    numericsimple
  },

  computed: {
    ...mapState("main", ["vatTypes", "currencies", "suppliers"]),
    currencyOptions() {
      return {
        currency: null,
        locale: "no-NO"
      };
    },
    supplierProductToBeWatched() {
      return this.article.supplierProduct.map(item => ({ ...item }));
    }
  },

  watch: {
    supplierProductToBeWatched: {
      async handler(newValue, oldValue) {
        if (!oldValue) return;

        if (newValue.length !== oldValue.length) {
          await this.updateSupplierProductPriorities(newValue);
          return;
        }

        await this.updateChangedPriorities(newValue, oldValue);
      },
      immediate: false,
      deep: true
    },
    showSupplierProduct: {
      async handler(newValue) {
        if(newValue == false) {
          this.isSupplierFieldNotSet = false;
        }
      }
    }
  },

  methods: {
    async updateChangedPriorities(newValue, oldValue) {
      const updatedProducts = [];

      newValue.forEach((newProduct, index) => {
        const oldProduct = oldValue[index];
        if (newProduct.priority !== oldProduct.priority) {
          updatedProducts.push({
            id: newProduct.id,
            dto: { ...newProduct }
          });
        }
      });

      if (!updatedProducts.length) return;

      await this.updateSupplierProducts(updatedProducts);
    },

    async updateSupplierProductPriorities(newValue) {
      const updatedProducts = [];

      newValue.forEach((product, idx) => {
        if (product.priority !== idx + 1) {
          product.priority = idx + 1;
          updatedProducts.push({
            id: product.id,
            dto: { ...product }
          });
        }
      });

      if (!updatedProducts.length) return;

      await this.updateSupplierProducts(updatedProducts);
    },

    async updateSupplierProducts(updatedProducts) {
      try {
        await Promise.all(
          updatedProducts.map(product =>
            this.putSupplierProduct({
              id: product.id,
              dto: product.dto
            })
          )
        );
        this.$q.notify({
          type: "positive",
          message: this.$t("common.saveOk")
        });
      } catch (error) {
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorSave")
        });
      }
    },

    onDragEnd() {
      const updatedSupplierProduct = [...this.article.supplierProduct];
      for (let i = 0; i < updatedSupplierProduct.length; i++) {
        updatedSupplierProduct[i].priority = i + 1;
      }

      this.article.supplierProduct = updatedSupplierProduct;
    },

    async delSupplierProduct() {
      if (this.selectedProductSupplier.id) {
        await this.deleteSupplierProduct(this.selectedProductSupplier.id);
        this.$q.notify({
          type: "positive",
          message: this.$t("common.saveOk")
        });

        this.article.supplierProduct = this.article.supplierProduct.filter(
          x => x.id != this.selectedProductSupplier.id
        );
      }
    },

    adjustCurrency() {
      if (this.selectedProductSupplier.supplierId) {
        var currencyId = this.suppliers.find(
          x => x.id == this.selectedProductSupplier.supplierId
        ).currencyCodeID;

        if (currencyId) {
          this.selectedProductSupplier.currencyCodeId = currencyId;
        } else {
          this.selectedProductSupplier.currencyCodeId = 1;
        }
      }
    },

    getCurrencyCode(row) {
      if (row.currencyCodeId) {
        var currency = this.currencies.find(x => x.id === row.currencyCodeId);
        if (currency) {
          return currency.code;
        }
      }

      return "";
    },
    getSupplierFilter(val, update) {
      if (!this.suppliers) {
        update();
        return;
      }
      update(() => {
        this.Suppliers = this.FilterSuppliers.filter(
          (w) =>
            w.name.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
            w.supplierNumber
              .toString()
              .toLowerCase()
              .indexOf(val.toLowerCase()) > -1
        );
      });
    },
    newSupplierProduct() {
      this.selectedProductSupplier = {};
      this.showSupplierProduct = true;
    },

    getNextPriority() {
      if (
        !this.article.supplierProduct ||
        this.article.supplierProduct.length === 0
      ) {
        return 1;
      }
      return (
        Math.max(...this.article.supplierProduct.map(val => val.priority)) + 1
      );
    },

    async saveSupplierProduct() {
      if(!this.selectedProductSupplier.supplierId) {
        this.$q.notify({
          type: "negative",
          message: "Mangler leverandør"
        });

        this.isSupplierFieldNotSet = true;
        return;
      }

      if (this.selectedProductSupplier.id) {
        var updatedDto = await this.putSupplierProduct({
          id: this.selectedProductSupplier.id,
          dto: this.selectedProductSupplier
        });
        this.$q.notify({
          type: "positive",
          message: this.$t("common.saveOk")
        });
        this.selectedProductSupplier = updatedDto;
      } else {
        this.selectedProductSupplier.productId = this.article.id;
        this.selectedProductSupplier.priority = this.getNextPriority();
        var newDto = await this.postSupplierProduct(
          this.selectedProductSupplier
        );
        this.$q.notify({
          type: "positive",
          message: this.$t("common.saveOk")
        });
        this.article.supplierProduct.push(newDto);
      }

      this.showSupplierProduct = false;
    },

    async runPriceCalculation(type) {
      var dto = {
        id: this.article.id,
        type: type
      };

      await this.runPriceCalculationForProduct(dto);

      this.$q.notify({
        type: "positive",
        message: "Kalkyle kjørt"
      });
      this.getProduct(this.internalID);
    },

    onRowClickSupplierProduct(evt, row) {
      this.selectedProductSupplier = row;

      this.showSupplierProduct = true;
    },

    async getProduct(internalId) {
      if (internalId == 0) {
        this.article = {
          country: { id: 0 },
          id: 0,
          extId: null,
          productNumber: "",
          productName: "",
          productDescription: "",
          created: null,
          createdBy: null,
          updated: null,
          lastUpdatedBy: null,
          type: 1,
          status: null,
          vatTypeId: 0,
          purchaseVatTypeId: 0,
          vatName: null,
          accountID: null,
          purchaseAccountID: null,
          accountName: null,
          unit: null,
          alternativeProductId: null,
          costPrice: null,
          priceIncVat: null,
          weightedAverageCostPrice: null,
          priceExVat: null,
          listPrice: null,
          avarageCost: null,
          calculateGrossPriceBasedOnNetPrice: false,
          serialNumberEnabled: false,
          conversionFactor: null,
          dimension1Id: null,
          dimension1Value: null,
          dimension2Id: null,
          dimension2Value: null,
          dimension3Id: null,
          dimension3Value: null,
          dimension4Id: null,
          dimension4Value: null,
          dimension5Id: null,
          dimension5Value: null,
          dimension6Id: null,
          dimension6Value: null,
          dimension7Id: null,
          dimension7Value: null,
          dimension8Id: null,
          dimension8Value: null,
          dimension9Id: null,
          dimension9Value: null,
          maximumPoint: null,
          minimumPoint: null,
          supplierProduct: this.supplierProduct,
          barcodes: []
        };
      } else {
        this.article = await this.getArticle(internalId);

        if (this.article.status == 0) {
          this.textClass = "text-red";
          this.deleted = "warning";
          this.productInfoIcon = this.$t("products.productInfoIcon");
        }

        if(this.article.country == null)
        {
          this.article.country = {id:null}
        }
      }
      if (this.article.vatTypeId == null) this.article.vatTypeId = 0;
      if (this.article.accountID == null) this.article.accountID = 0;
      if (this.article.purchaseVatTypeId == null)
        this.article.purchaseVatTypeId = 0;
      if (this.article.purchaseAccountID == null)
        this.article.purchaseAccountID = 0;
      if (this.article.serialNumberEnabled == null)
        this.article.serialNumberEnabled = false;
      this.productNumber = this.article.productNumber;
      this.storageTab =
        this.article.type == 1 || this.article.type == 4 ? "storage" : "bought";
      this.article.supplierProduct = this.article.supplierProduct.sort(
        (a, b) => a.priority - b.priority
      );
    },

    findSupplierNo(supplierId) {
      var filteredSuppliers = this.suppliers.filter(x => x.id == supplierId);

      if(filteredSuppliers.length == 1) {
        return filteredSuppliers[0].supplierNumber;
      }
      else {
        this.$q.notify({
          type: "negative",
          message: `Finner flere leverandører med Id ${supplierId}. Data feil`
        });

        return "Data feil";
      }
    },

    async saveProduct() {
      this.savedisabled = true;
      try {
        var dto = {};
        if(this.article.priceCalculationId == null)
          this.article.priceCalculationId = 0;

        dto.productName = this.article.productName;
        dto.productNumber = this.article.productNumber;
        dto.extId = this.article.extId;
        dto.unit = this.article.unit;
        dto.alternativeProductId = this.article.alternativeProductId;
        dto.type = this.article.type;
        dto.weight = this.article.weight;
        dto.productDescription = this.article.productDescription;
        dto.status = this.article.status;
        dto.costPrice = this.article.costPrice;
        dto.serialNumberEnabled = this.article.serialNumberEnabled;
        dto.conversionFactor = this.article.conversionFactor;
        dto.mainComponent = this.article.mainComponent;

        dto.weightedAverageCostPrice = this.article.weightedAverageCostPrice;

        dto.vatTypeId = this.article.vatTypeId;
        dto.accountID = this.article.accountID;
        dto.purchaseAccountId = this.article.purchaseAccountID;
        dto.purchaseVatTypeId = this.article.purchaseVatTypeId;

        dto.dimension1Id = this.article.dimension1Id;
        dto.dimension2Id = this.article.dimension2Id;
        dto.dimension3Id = this.article.dimension3Id;
        dto.dimension4Id = this.article.dimension4Id;
        dto.dimension5Id = this.article.dimension5Id;
        dto.dimension6Id = this.article.dimension6Id;
        dto.dimension7Id = this.article.dimension7Id;
        dto.dimension8Id = this.article.dimension8Id;
        dto.dimension9Id = this.article.dimension9Id;

        dto.country = this.article.country;

        dto.tollCode = Number(this.article.tollCode) || 0; 
         
        dto.fullCost = this.article.fullCost === null ? 0 : this.article.fullCost;

        dto.priceCalculationId = this.article.priceCalculationId;

        dto.maximumPoint = parseFloat(this.article.maximumPoint);
        dto.minimumPoint = parseFloat(this.article.minimumPoint);
        dto.purchaseFrequencyDays = parseInt(
          this.article.purchaseFrequencyDays
        );

        dto.calculateGrossPriceBasedOnNetPrice = this.article.calculateGrossPriceBasedOnNetPrice;
        dto.priceExVat = this.article.priceExVat;

        dto.barcodes = this.article.barcodes;
        dto.components = this.article.components;

        dto.supplierProduct = this.article.supplierProduct;
        if (!dto.supplierProduct.supplierId) dto.supplierProduct.supplierId = 0;

        if (this.internalID == 0) {
          var createdDto = await this.postArticle(dto);
          this.internalID = createdDto.id;
          this.article.barcodes = createdDto.barcodes;

          this.article.components = createdDto.components;
          this.$q.notify({
            type: "positive",
            message: this.$t("common.saveOk")
          });
          router.push({
            name: "EditProduct",
            params: { id: this.internalID }
          });
        } else {
          var updateddto = await this.putArticle({
            internalID: this.internalID,
            productDto: dto
          });

          this.article.barcodes = updateddto.barcodes;

          this.article.components = updateddto.components;

          this.$q.notify({
            type: "positive",
            message: this.$t("common.saveOk")
          });
        }
      } catch (error) {
        this.$q.notify({
          type: "negative",
          message: `${this.$t(
            "common.errorSave"
          )}. ${this.$utils.GetErrorMessage(error)}`
        });
      }
      this.savedisabled = false;
    },

    newProduct() {
      router.push({ name: "EditProduct", params: { id: 0 } });
    },

    onReset() {},

    prevItem() {
      var i = parseFloat(this.internalID);
      router.push({
        name: "EditProduct",
        params: { id: i - 1 }
      });
    },

    nextItem() {
      var i = parseFloat(this.internalID);
      router.push({
        name: "EditProduct",
        params: { id: i + 1 }
      });
    },

    ...mapActions("main", [
      "getArticle",
      "putArticle",
      "postArticle",
      "getSupplierProduct",
      "postSupplierProduct",
      "putSupplierProduct",
      "deleteSupplierProduct",
      "runPriceCalculationForProduct"
    ])
  },

  created() {
    this.internalID = this.$route.params.id;
    this.Suppliers = this.suppliers.filter(x => x.statusCode != this.SupplierStatus.Inactive);
    this.FilterSuppliers = this.suppliers.filter(x => x.statusCode != this.SupplierStatus.Inactive);
    this.getProduct(this.internalID);
  },

  beforeRouteUpdate(to, from, next) {
    this.internalID = to.params.id;
    this.getProduct(this.internalID);
    next();
  }
};
